import React from 'react';
import {
  IconWorld
} from '@tabler/icons-react';
import { formatBytes } from '../../utils/format';

const CountryFlag = ({ countryCode }) => {
  if (!countryCode || countryCode.length !== 2) {
    return <IconWorld className="w-5 h-5 text-gray-400" />;
  }
  return (
    <span 
      className={`fi fi-${countryCode.toLowerCase()} fis rounded-sm`}
      style={{ fontSize: '1.2em' }}
    />
  );
};

const TopIPsTable = ({ ipStats, limit = 8 }) => {
  if (!ipStats || ipStats.length === 0) {
    return (
      <tr>
        <td colSpan="3" className="py-6 text-center text-gray-500 dark:text-dark-500">
          Нет данных
        </td>
      </tr>
    );
  }

  return ipStats.slice(0, limit).map((ip, idx) => (
    <tr key={idx} className="border-b border-gray-100 dark:border-dark-800/50">
      <td className="py-2 px-3">
        <div className="flex items-center gap-2">
          <CountryFlag countryCode={ip.country} />
          <span className="font-mono text-gray-900 dark:text-white text-sm">{ip.ip}</span>
        </div>
      </td>
      <td className="py-2 px-3 text-center">
        <span className="text-sm text-gray-600 dark:text-dark-400">{ip.connections}</span>
      </td>
      <td className="py-2 px-3 text-right text-gray-600 dark:text-dark-400 text-sm">
        {formatBytes(ip.total_bytes || 0)}
      </td>
    </tr>
  ));
};

export default TopIPsTable;
